<template>
  <div class="about">
    <div style="height: calc(100vh / 2); position: relative">
      <video
        :autoplay="true"
        :muted="true"
        :playsinline="true"
        :loop="true"
        controls
        :src="
          'https://nncms.actstudio.xyz/storage/uploads/' + about.videoFondo.path
        "
        style="
          position: absolute;
          width: 100%;
          height: 100%;
          object-fit: cover;
          z-index: 0;
        "
      ></video>
      <div
        style="
          z-index: 1;
          position: relative;
          background-color: #5c27b2a6;
          height: calc(100vh / 2);
        "
      >
        <div
          style="
            z-index: 1;
            position: relative;
            background: rgb(90, 35, 178);
            background: linear-gradient(
              0deg,
              rgba(90, 35, 178, 0) 12%,
              rgba(90, 35, 178, 0.5452381636248249) 52%,
              rgba(90, 35, 178, 1) 100%
            );
            margin-bottom: 100px;
          "
        >
          <v-container>
            <v-row
              align="center"
              style="position: relative; height: calc((100vh - 110px) / 2)"
            >
              <v-col cols="12" sm="8" md="10">
                <!-- <span class="subtitulo color-blanco d-block mb-8"
                  >Acerca de Neutral Networks</span
                > -->
                <span
                  class="montserrat bold enfasis-size d-block mb-3 color-blanco"
                >
                  {{ about.descripcionPrincipal }}
                </span>
                <v-dialog
                  transition="dialog-bottom-transition"
                  max-width="960px"
                  class="py-0"
                  v-model="dialogActive"
                >
                  <template
                    v-slot:activator="{ on, attrs }"
                    class="d-none d-sm-flex"
                  >
                    <v-img
                      src="../assets/img/play-button.svg"
                      v-bind="attrs"
                      v-on="on"
                      width="60"
                      @click="playVid()"
                    ></v-img>
                  </template>

                  <video
                    :src="
                      'https://nncms.actstudio.xyz/storage/uploads/' +
                      about.videoFull.path
                    "
                    :autoplay="true"
                    :playsinline="true"
                    style="height: 90%; width: 100%"
                    controls
                    v-if="dialogActive"
                  ></video>
                </v-dialog>
                <hr class="mt-5" style="max-width: 70%; color: #fff" />
              </v-col>
            </v-row>
          </v-container>
        </div>
      </div>
    </div>

    <div class="" style="background-color: #5c27b2">
      <v-container class="pb-5 py-md-5">
        <v-row
          style="color: #fff"
          class="py-10"
          justify="center"
          align="start"
          align-md="end"
        >
          <v-col cols="12" sm="10" md="8" class="text-center">
            <span class="titulos-size-bold color-blanco"
              >{{ about.tituloNeutralidad }}
            </span>
          </v-col>
          <v-col cols="12" sm="10" md="8" class="pb-10">
            <p style="single-item-size">
              {{ about.descripcionNeutralidad }}
            </p>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="color-morado-2">
      <v-container>
        <v-row>
          <v-col class="py-12 text-left" cols="12" sm="6" md="6">
            <span class="montserrat bold titulos-size d-block mb-4">{{
              about.tituloVision
            }}</span>

            <p style="single-item-size color-morado">
              {{ about.descripcionVision }}
            </p>
          </v-col>
          <v-col class="py-12 text-left" cols="12" sm="6" md="6">
            <span class="montserrat bold titulos-size d-block mb-4">{{
              about.tituloMision
            }}</span>

            <p style="single-item-size color-morado">
              {{ about.descripcionMision }}
            </p>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="">
      <v-container class="px-5">
        <v-row class="pb-0">
          <v-col class="text-center py-0" cols="12">
            <template v-if="locale == 'en'">
              <span class="enfasis-size-bold">How we do it?</span>
            </template>
            <template v-else>
              <span class="enfasis-size-bold">¿Cómo lo hacemos?</span>
            </template>
          </v-col>
        </v-row>
        <v-row class="pb-16 pt-5 px-0">
          <v-col
            cols="12"
            sm="4"
            md="4"
            class="pb-16"
            v-for="(cards, car) in about.tarjetas"
            :key="'targetas-' + car"
          >
            <v-card color="#48306E" dark height="100%" elevation="0">
              <v-img
                class="end-align"
                :src="'https://nncms.actstudio.xyz/' + cards.value.imagen.path"
                height="120px"
                position="center top"
              ></v-img>
              <v-card-text class="py-16">
                <span class="titulos-size bold white--text">{{
                  cards.value.titulo
                }}</span>
                <br />
                <br />
                <p class="single-item-size color-blanco white--text">
                  {{ cards.value.descripcion }}
                </p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="color-morado">
      <v-container fluid class="content-background-2 py-0">
        <v-row>
          <v-col class="pa-0">
            <v-img src="../assets/img/about-even-fondo.jpg" position="center center" height="400" class="align-center justify-center text-center d-none d-sm-flex">
              <div class="d-flex align-center justify-center text-center" style="width: 100%; height: 400px; background-color: #5c27b2a6;">
                <v-img
                  src="../assets/img/an-evengroup-company_logo-blanco.svg"
                  max-width="600"
                  class="d-block mx-auto"
                ></v-img>
              </div>
            </v-img>
            <v-img src="../assets/img/about-even-fondo.jpg"  width="100%" :contain="true" class=" justify-center text-center d-sm-none" style="position: relative;">
              <div class="fill-height text-center align-center d-flex" style="background-color: #5c27b2a6;">

                <v-img
                  src="../assets/img/an-evengroup-company_logo-blanco.svg"
                  max-width="90%"
                  class="d-block mx-auto"
                ></v-img>
              </div>

              <!-- <div class="align-center justify-center text-center" style="width: 100%; height: 100% !important; background-color: #5c27b2a6; position: relative;">
                
              </div> -->
            </v-img>
          </v-col>
        </v-row>
      </v-container>
      <div class="">
        <v-container>
          <v-row justify="center">
            <v-col class="text-center py-12" md="7" xl="6">
              <p>{{ about.abstractoSeccionFinal }}</p>
              <p>{{ about.parrafo1 }}</p>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div class="content-background-2">
        <v-container fluid>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="6" order="2" order-sm="0" class="text-center text-sm-left">
              <p class="mx-auto" style="max-width: 450px">{{ about.parrafo2 }}</p>
            </v-col>
            <v-col cols="12" sm="6" class="text-center pa-0" order="1">
              <v-img :src="'https://www.nncms.actstudio.xyz/'+about.imagenParrafo2.path" height="400px" :contain="false"></v-img>
              <!-- <v-avatar size="300">
                <v-img :src="'https://www.nncms.actstudio.xyz/'+about.imagenParrafo2.path"></v-img>
              </v-avatar> -->
            </v-col>
          </v-row>
        </v-container>
      </div>

      <!-- <div>
        <v-container>
          <v-row align="center" justify="center">
            <v-col cols="auto" class="text-center">
              <v-avatar size="300">
                <v-img :src="'https://www.nncms.actstudio.xyz/'+about.imagenParrrafo3.path"></v-img>
              </v-avatar>
            </v-col>
            <v-col cols="12" sm="5" xl="4" class="text-center text-sm-left">
              <p>{{ about.parrafo3 }}</p>
            </v-col>
          </v-row>
        </v-container>
      </div> -->

      <v-container>
        <v-row justify="center">
          <v-col class="text-center py-12" md="7" xl="6">
            <p>{{ about.parrafo3 }}</p>
            
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col cols="auto">
            <a href="https://www.nhsolutions.mx/" target="_blank">
              <v-img src="../assets/img/logo-nh.webp" height="100px" width="300px" contain position="center center"></v-img>
            </a>
          </v-col>
          <v-col cols="auto">
            <a href="https://eventelecom.mx/" target="_blank">
              <v-img src="../assets/img/logo-even.webp" height="100px" width="300px" contain position="center center"></v-img>
            </a>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col class="text-center py-12" md="7" xl="6">
            <p>{{about.parrafo4}}</p>
          </v-col>
        </v-row>
      </v-container>


<!-- 
      <v-container class="py-10">
        <div>
          <v-row align="center" class="py-5">
            <v-col cols="12" sm="6" order="0">
              <span class="titulos-size-bold color-morado-2">{{
                about.tituloSeccionFinal
              }}</span>
              <br />
              <br />
              <p style="single-item-size">
                {{ about.abstractoSeccionFinal }}
              </p>
            </v-col>
            <v-col cols="12" sm="4" offset-sm="1" order="1">
              <v-img
                src="../assets/img/an-evengroup-company.jpg"
                width="100%"
                class="align-items-center align-center text-center"
              >
                <v-img
                  src="../assets/img/an-evengroup-company_logo-blanco.svg"
                  width="255"
                  class="d-block mx-auto"
                ></v-img>
              </v-img>
            </v-col>
          </v-row>
        </div>

        <v-row class="px-4" align="center">
          <v-col cols="12" sm="6" md="6">
            <p style="single-item-size">
              {{ about.parrafo1 }}
            </p>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-img
              src="../assets/img/an-evengroup-company.jpg"
              width="100%"
              class="d-block mx-auto"
            ></v-img>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-img
              src="../assets/img/an-evengroup-company.jpg"
              width="100%"
              class="d-block mx-auto"
            ></v-img>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <p style="single-item-size">
              {{ about.parrafo2 }}
            </p>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <p style="single-item-size">
              {{ about.parrafo3 }}
            </p>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-img
              src="../assets/img/an-evengroup-company.jpg"
              width="100%"
              class="d-block mx-auto"
            ></v-img>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-img
              src="../assets/img/an-evengroup-company.jpg"
              width="100%"
              class="d-block mx-auto"
            ></v-img>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <p style="single-item-size">
              {{ about.parrafo4 }}
            </p>
          </v-col>
        </v-row>
      </v-container> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      about: {
        videoFondo: {
          path: "",
        },
      },
      isPlaying: true,
      dialogActive: false,
      loaded: false
    };
  },
  mounted: function () {
    if (this.locale == "en") {
      fetch(
        "https://nncms.actstudio.xyz/api/singletons/get/Acerca?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            lang: "en",
          }),
        }
      )
        .then((data) => data.json())
        .then((data) => (this.about = data))
        .then(() => this.loaded = true)
    } else {
      fetch(
        "https://nncms.actstudio.xyz/api/singletons/get/Acerca?token=8cf7ca41761951fdde0c1e2cfda401"
      )
        .then((data) => data.json())
        .then((data) => (this.about = data))
        .then(() => this.loaded = true)
    }

    this.$gtag.pageview({ page_path: '/acerca-de', page_title: 'About' })
  },
  methods: {
    playVid: function () {
      var vid = document.getElementById("control-video");

      if (this.isPlaying) {
        vid.pause();
        this.isPlaying = false;
      } else {
        vid.play();
        this.isPlaying = true;
      }
    },
  },
  computed: {
    locale: function () {
      return this.$i18n.locale;
    },
  },
  watch: {
    locale: function () {
      this.loaded = false
      if (this.locale == "en") {
        fetch(
          "https://nncms.actstudio.xyz/api/singletons/get/Acerca?token=8cf7ca41761951fdde0c1e2cfda401",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              lang: "en",
            }),
          }
        )
          .then((data) => data.json())
          .then((data) => (this.about = data))
          .then(() => this.loaded = true)
      } else {
        fetch(
          "https://nncms.actstudio.xyz/api/singletons/get/Acerca?token=8cf7ca41761951fdde0c1e2cfda401"
        )
          .then((data) => data.json())
          .then((data) => (this.about = data))
          .then(() => this.loaded = true)
      }
    },
  },
};
</script>
